import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

interface ICardHeaderProps {
    title: string,
    description: string,
}

const CardHeader = ({
    title,
    description,
}: ICardHeaderProps): JSX.Element => {
    return (
        <TextWrapper>
            <H4 $withIndent={false}>{title}</H4>
            <ST.ParagraphWithOverflowLineClamp
                $smaller
                $color={COLORS.TextSecondary}
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </TextWrapper>
    );
};

export default CardHeader;
